export const GET_PROJECT_DATA_ALL = 'GET_PROJECT_DATA_ALL'
export const GET_PROJECT_DETAIL = 'GET_PROJECT_DETAIL'
export const GET_PROJECT_TYPE_ALL = 'GET_PROJECT_TYPE_ALL'
export const GET_PROJECT_LOCATION_ALL = 'GET_PROJECT_LOCATION_ALL'
export const POST_ORDER_PROJECT = 'POST_ORDER_PROJECT'
export const PUT_PROJECT_STATUS = 'PUT_PROJECT_STATUS'
export const POST_RECEIPT = 'POST_RECEIPT'
